export default __webpack_public_path__ + "static/media/img.de3ad416.svg";